import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Sorry, you don't have the access to this page.", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Check "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://playgama.com"
}, " Our games "), /*#__PURE__*/_createTextVNode(", or if you want to publish your game welcome to "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://developer.playgama.com"
}, " Playgama Developers Console ")], -1);
import { ref } from 'vue';
import { useUserStore } from '@/store/user.store';
import GoogleAuth from '@/components/GoogleAuth.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminRoleProvider',
  setup(__props) {
    const isReady = ref(false);
    const userStore = useUserStore();
    userStore.checkUserLoggedIn().then(() => {
      isReady.value = true;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return isReady.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(userStore).authorized ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style.wrapper)
      }, [_hoisted_1, _hoisted_2, _createVNode(GoogleAuth)], 2)) : (_openBlock(), _createBlock(_component_router_view, {
        key: 1
      }))], 64)) : _createCommentVNode("", true);
    };
  }
});